import _ from 'lodash';

class LanguageService {
  private language?: string;

  registerLanguage(language?: string) {
    if (language) {
      this.language = language;
    }
  }

  get() {
    return this.language;
  }

  getTextWithLanguage(texts: string) {
    if (this.language) {
      if (_.has(texts, this.language)) {
        return texts[this.language];
      }
      console.warn(
        `LanguageService - no language set for text ${this.language}`,
      );
    }
    const key = Object.keys(texts)[0];
    return texts[key];
  }
}

export default new LanguageService();
